import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from '../../components/Button';
import { ExameCard } from '../../components/ExameCard';
import Input from '../../components/Input';
import InputMask from '../../components/InputMask';
import {
  apiHnsn,
  apiLaureano,
  apiLaureanoSoul,
  apiPhato,
} from '../../services/api';
import { fetchPhatoExamePdf } from '../../services/phatoExame';
import {
  ActionsBar,
  ClearFiltersButton,
  SelectedLaudosButton,
  Container,
  FilterField,
  Form,
  Header,
  HeaderButton,
  HeaderPhoneButton,
  Imagem,
  LaudoNoContent,
  List,
  Logo,
  User,
  UserGretting,
  UserInfo,
} from './styles';

import { Dialog, Tooltip } from '@material-ui/core';
import axios from 'axios';
import { PDFDocument } from 'pdf-lib';
import { DeviceMobile } from 'phosphor-react';
import logo from '../../assets/CEDAPP_ICONE.png';
import { PhoneDialog } from './PhoneDialog';
import { AdminSearchDialog } from './AdminSearchDialog';
import { AcessosDialog } from './AcessosDialog';
import {
  filterLaudosByNomePaciente,
  filterPhatoLaudos,
  LaudoExame,
  resolveUsuarioNome,
  useDashboard,
} from './use-dashboard';
import { toast } from 'react-toastify';

export function Dashboard() {
  const {
    handleGetLaudosBusiness,
    laudos: businessLaudos,
    signOut,
    usuarioHnsn,
    usuarioPhato,
    usuarioLaureano,
    usuarioLaureanoSoul,
    phatoAccess,
    handleGetPhatoProductivity,
    handleGetLegacyLaudos,
    isLegacyPatient,
    tokenPhato,
    showLoader,
    hideLoader,
    handleFilterBusinessLaudos,
    handleVisualizarLaudo,
    handleGetLaudoAcessos,
  } = useDashboard();
  const [filtro, setFiltro] = useState('');
  const [medicoCpf, setMedicoCpf] = useState('');
  const [medicoNomePaciente, setMedicoNomePaciente] = useState('');
  const [adminCrm, setAdminCrm] = useState('');
  const [adminCpf, setAdminCpf] = useState('');
  const [adminNomePaciente, setAdminNomePaciente] = useState('');
  const [selectedLaudos, setSelectedLaudos] = useState<LaudoExame[]>([]);

  const [changeNumberDialog, setChangeNumberDialog] = useState(false);
  const [adminSearchDialog, setAdminSearchDialog] = useState(false);
  const [acessosModal, setAcessosModal] = useState<{
    cdLaudo: string;
    from: LaudoExame['from'];
    nmPaciente: string;
  } | null>(null);
  const [legacyLaudos, setLegacyLaudos] = useState<LaudoExame[]>([]);
  const [phatoLaudos, setPhatoLaudos] = useState<LaudoExame[]>([]);
  const [filteredPhatoLaudos, setFilteredPhatoLaudos] = useState<
    LaudoExame[]
  >([]);
  const [isAdminSearchActive, setIsAdminSearchActive] = useState(false);

  const isBusiness = sessionStorage.getItem('@cedapp:isBusiness');
  const isPaciente =
    !isBusiness && (isLegacyPatient() || phatoAccess?.isMedico === false);
  const laudos = useMemo(
    () =>
      isBusiness
        ? businessLaudos
        : [...filteredPhatoLaudos, ...legacyLaudos],
    [businessLaudos, filteredPhatoLaudos, legacyLaudos, isBusiness],
  );
  const isAdmin =
    usuarioPhato?.crm === '00009' ||
    usuarioLaureano?.crm === '00009' ||
    usuarioLaureanoSoul?.crm === '00009' ||
    phatoAccess?.crm === '00009' ||
    usuarioHnsn?.crm === '00009' ||
    usuarioPhato?.crm === '00000' ||
    usuarioLaureano?.crm === '00000' ||
    usuarioLaureanoSoul?.crm === '00000' ||
    phatoAccess?.crm === '00000' ||
    usuarioHnsn?.crm === '00000';

  const isMedicoPhato = Boolean(phatoAccess?.isMedico && !isAdmin);
  const hasActiveFilter =
    Boolean(filtro.trim()) ||
    Boolean(medicoCpf.replace(/\D/g, '')) ||
    Boolean(medicoNomePaciente.trim()) ||
    isAdminSearchActive;

  const nomeUsuario = resolveUsuarioNome({
    usuarioHnsn,
    usuarioPhato,
    usuarioLaureano,
    usuarioLaureanoSoul,
    phatoAccess,
    phatoLaudos,
    isAdmin,
  });

  function getNormalizedStatus(status: string) {
    return status
      ?.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  }

  function isLaudoConcluido(laudo: LaudoExame) {
    return getNormalizedStatus(laudo.status)?.startsWith('CONCLU') === true;
  }

  function getLaudoKey(laudo: LaudoExame) {
    return `${laudo.from}-${laudo.cdLaudo}`;
  }

  function openSingleLaudo(laudo: LaudoExame) {
    sessionStorage.setItem('@cedapp:from', laudo.from);
    window.open(`/laudo/${laudo.cdLaudo}`, '_blank');
  }

  function getLaudoPdfUrl(laudo: LaudoExame) {
    if (laudo.from === 'LAUREANO') {
      return `${apiLaureanoSoul.defaults.baseURL}/laudo/android/${sessionStorage.getItem(
        '@cedapp:tokenLaureanoSoul',
      )}/${laudo.cdLaudo}`;
    }

    if (laudo.from === 'LAUREANO_MV2000') {
      return `${apiLaureano.defaults.baseURL}/laudo/android/${sessionStorage.getItem(
        '@cedapp:tokenLaureano',
      )}/${laudo.cdLaudo}`;
    }

    return `${apiHnsn.defaults.baseURL}/laudo/android/${sessionStorage.getItem(
      '@cedapp:tokenHnsn',
    )}/${laudo.cdLaudo}`;
  }

  function writePdfLoadingPage(pdfWindow: Window) {
    pdfWindow.document.open();
    pdfWindow.document.write(`
      <!doctype html>
      <html lang="pt-BR">
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <title>Gerando PDF</title>
          <style>
            * {
              box-sizing: border-box;
            }

            body {
              min-height: 100vh;
              margin: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #f8f8f8;
              color: #1f2933;
              font-family: Arial, Helvetica, sans-serif;
            }

            main {
              width: min(420px, calc(100vw - 40px));
              text-align: center;
            }

            .spinner {
              width: 64px;
              height: 64px;
              margin: 0 auto 24px;
              border: 6px solid #d8ebe8;
              border-top-color: #007467;
              border-radius: 50%;
              animation: spin 0.9s linear infinite;
            }

            h1 {
              margin: 0 0 10px;
              color: #007467;
              font-size: 24px;
            }

            p {
              margin: 0;
              font-size: 16px;
              line-height: 1.5;
            }

            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
          </style>
        </head>
        <body>
          <main>
            <div class="spinner" aria-hidden="true"></div>
            <h1>Gerando PDF</h1>
            <p>Aguarde enquanto os laudos selecionados são preparados.</p>
          </main>
        </body>
      </html>
    `);
    pdfWindow.document.close();
  }

  function handleToggleLaudoSelection(laudo: LaudoExame) {
    if (!isLaudoConcluido(laudo)) {
      return;
    }

    setSelectedLaudos((currentSelectedLaudos) => {
      const laudoKey = getLaudoKey(laudo);
      const alreadySelected = currentSelectedLaudos.some(
        (selectedLaudo) => getLaudoKey(selectedLaudo) === laudoKey,
      );

      if (alreadySelected) {
        return currentSelectedLaudos.filter(
          (selectedLaudo) => getLaudoKey(selectedLaudo) !== laudoKey,
        );
      }

      return [...currentSelectedLaudos, laudo];
    });
  }

  async function handleGenerateSelectedLaudosPdf(laudosToMerge: LaudoExame[]) {
    const pdfWindow = window.open('', '_blank');

    if (!pdfWindow) {
      toast.error('Nao foi possivel abrir uma nova guia para o PDF.');
      return;
    }

    writePdfLoadingPage(pdfWindow);
    void handleVisualizarLaudosAndRefresh(laudosToMerge);

    try {
      showLoader();

      const mergedPdf = await PDFDocument.create();

      for (const laudo of laudosToMerge) {
        const pdfBytes =
          laudo.from === 'PHATO'
            ? (
                await fetchPhatoExamePdf(
                  apiPhato,
                  laudo.cdLaudo,
                  tokenPhato || sessionStorage.getItem('@cedapp:tokenPhato'),
                )
              ).bytes
            : new Uint8Array(
                (
                  await axios.get(getLaudoPdfUrl(laudo), {
                    responseType: 'arraybuffer',
                  })
                ).data,
              );

        const pdf = await PDFDocument.load(pdfBytes);
        const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());

        pages.forEach((page) => {
          mergedPdf.addPage(page);
        });
      }

      const mergedPdfBytes = (await mergedPdf.save()) as any;
      const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      pdfWindow.location.href = blobUrl;
      setSelectedLaudos([]);

      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 60000);
    } catch (error) {
      pdfWindow.close();
      toast.error('Erro ao gerar o PDF dos laudos selecionados.');
    } finally {
      hideLoader();
    }
  }

  function handlePdfClick(laudo: LaudoExame) {
    void handleVisualizarLaudosAndRefresh([laudo]);
    openSingleLaudo(laudo);
  }

  function normalizeLaudos(items: LaudoExame[]) {
    const sorted = [...items].sort((first, second) => {
      const parseDate = (value: string) => {
        if (!value) return 0;
        const [day, month, year] = value.split('/');
        return new Date(Number(year), Number(month) - 1, Number(day)).getTime();
      };

      return parseDate(second.dtLaudo) - parseDate(first.dtLaudo);
    });

    return sorted.filter((item, index, allItems) => {
      const sameExam = (candidate: LaudoExame) =>
        candidate.from === item.from && candidate.nrControle === item.nrControle;
      const hasFinishedVersion = allItems.some(
        (candidate) => sameExam(candidate) && candidate.status === 'CONCLUÍDO',
      );

      if (item.status === 'EM ANDAMENTO' && hasFinishedVersion) return false;
      if (item.status !== 'EM ANDAMENTO') return true;

      return (
        allItems.findIndex(
          (candidate) =>
            sameExam(candidate) && candidate.status === 'EM ANDAMENTO',
        ) === index
      );
    });
  }

  const loadData = useCallback(async () => {
    const isBusiness = sessionStorage.getItem('@cedapp:isBusiness');
    if (isBusiness) {
      await handleGetLaudosBusiness();
      return;
    }
    showLoader();

    try {
      const [phatoResult, legacyResult] = await Promise.allSettled([
        handleGetPhatoProductivity(),
        handleGetLegacyLaudos(),
      ]);

      const loadedPhatoLaudos =
        phatoResult.status === 'fulfilled' ? phatoResult.value : [];
      const loadedLegacyLaudos =
        legacyResult.status === 'fulfilled'
          ? normalizeLaudos(legacyResult.value)
          : [];

      setPhatoLaudos(loadedPhatoLaudos);
      setFilteredPhatoLaudos(loadedPhatoLaudos);
      setLegacyLaudos(loadedLegacyLaudos);
    } finally {
      hideLoader();
    }
  }, [
    handleGetLaudosBusiness,
    handleGetPhatoProductivity,
    handleGetLegacyLaudos,
    showLoader,
    hideLoader,
  ]);

  async function handleVisualizarLaudosAndRefresh(
    laudosToVisualizar: LaudoExame[],
  ) {
    try {
      await Promise.allSettled(
        laudosToVisualizar.map((laudo) =>
          handleVisualizarLaudo(laudo.cdLaudo, laudo.from, nomeUsuario),
        ),
      );
      // await loadData();
    } catch (error) {}
  }

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    setSelectedLaudos([]);
  }, [laudos]);

  async function handleBuscarAdminPhato() {
    const crm = adminCrm.replace(/\D/g, '');
    const cpf = adminCpf.replace(/\D/g, '');
    const nomePaciente = adminNomePaciente.trim();

    if (cpf && nomePaciente) {
      toast.error('Não é possível combinar CPF com nome do paciente.');
      return;
    }

    if (!crm && !cpf && !nomePaciente) {
      toast.error('Informe CRM, CPF ou nome do paciente para buscar.');
      return;
    }

    showLoader();
    try {
      const filtros = {
        ...(crm ? { crm } : {}),
        ...(cpf ? { cpf } : {}),
        ...(nomePaciente ? { nomePaciente } : {}),
      };
      const legacyFiltro = crm || cpf || nomePaciente;
      const [phatoResult, legacyResult] = await Promise.allSettled([
        handleGetPhatoProductivity(filtros),
        handleGetLegacyLaudos(legacyFiltro),
      ]);

      let hasSearchError = false;

      if (phatoResult.status === 'fulfilled') {
        setPhatoLaudos(phatoResult.value);
        setFilteredPhatoLaudos(phatoResult.value);
      } else {
        setPhatoLaudos([]);
        setFilteredPhatoLaudos([]);
        hasSearchError = true;
      }

      if (legacyResult.status === 'fulfilled') {
        let loadedLegacy = normalizeLaudos(legacyResult.value);
        if (crm && nomePaciente) {
          loadedLegacy = filterLaudosByNomePaciente(
            loadedLegacy,
            nomePaciente,
          );
        }
        setLegacyLaudos(loadedLegacy);
      } else {
        setLegacyLaudos([]);
        hasSearchError = true;
      }

      if (hasSearchError) {
        toast.error('Não foi possível buscar exames em um dos sistemas.');
      }

      setIsAdminSearchActive(true);
      setAdminSearchDialog(false);
    } catch (error) {
      setPhatoLaudos([]);
      setFilteredPhatoLaudos([]);
      setLegacyLaudos([]);
      toast.error('Erro ao buscar exames.');
    } finally {
      hideLoader();
    }
  }

  async function handleLimparFiltros() {
    setFiltro('');
    setMedicoCpf('');
    setMedicoNomePaciente('');
    setAdminCrm('');
    setAdminCpf('');
    setAdminNomePaciente('');
    setIsAdminSearchActive(false);
    await loadData();
  }

  async function handleBuscarDados() {
    const isBusiness = sessionStorage.getItem('@cedapp:isBusiness');
    if (isBusiness) {
      await handleFilterBusinessLaudos(filtro);
      return;
    }

    if (isMedicoPhato) {
      const cpfPaciente = medicoCpf.replace(/\D/g, '');
      const nomePaciente = medicoNomePaciente.trim();

      if (cpfPaciente && nomePaciente) {
        toast.error('Não é possível combinar CPF com nome do paciente.');
        return;
      }

      if (cpfPaciente && cpfPaciente.length < 11) {
        toast.error('Informe o CPF completo do paciente.');
        return;
      }

      showLoader();
      try {
        const phatoFiltros =
          cpfPaciente || nomePaciente
            ? {
                ...(cpfPaciente ? { cpf: cpfPaciente } : {}),
                ...(nomePaciente ? { nomePaciente } : {}),
              }
            : undefined;
        const legacyFiltro = cpfPaciente || nomePaciente;

        const [phatoResult, legacyResult] = await Promise.allSettled([
          handleGetPhatoProductivity(phatoFiltros),
          handleGetLegacyLaudos(legacyFiltro || undefined),
        ]);

        if (phatoResult.status === 'fulfilled') {
          setPhatoLaudos(phatoResult.value);
          setFilteredPhatoLaudos(phatoResult.value);
        } else {
          setFilteredPhatoLaudos([]);
          toast.error('Erro ao buscar exames do Phato.');
        }

        setLegacyLaudos(
          legacyResult.status === 'fulfilled'
            ? normalizeLaudos(legacyResult.value)
            : [],
        );
      } finally {
        hideLoader();
      }
      return;
    }

    showLoader();
    try {
      const phatoRequest = Promise.resolve(
        filterPhatoLaudos(phatoLaudos, filtro),
      );
      const [phatoResult, legacyResult] = await Promise.allSettled([
        phatoRequest,
        handleGetLegacyLaudos(filtro),
      ]);

      if (phatoResult.status === 'fulfilled') {
        setFilteredPhatoLaudos(phatoResult.value);
      } else {
        setFilteredPhatoLaudos([]);
        toast.error('Erro ao buscar exames do Phato.');
      }

      setLegacyLaudos(
        legacyResult.status === 'fulfilled'
          ? normalizeLaudos(legacyResult.value)
          : [],
      );
    } finally {
      hideLoader();
    }
  }
  return (
    <Container>
      <Header>
        <Imagem>
          <Logo src={logo} alt="CEDAPP" />
        </Imagem>

        <UserInfo>
          <User>
            <UserGretting>Bem-vindo,</UserGretting>

            <h1>{nomeUsuario}</h1>
          </User>
        </UserInfo>
        {(usuarioPhato?.crm === '00009' ||
          usuarioLaureano?.crm === '00009' ||
          usuarioLaureanoSoul?.crm === '00009' ||
          phatoAccess?.crm === '00009') && (
          <HeaderPhoneButton>
            <Tooltip title="Trocar número de telefone">
              <Button onClick={() => setChangeNumberDialog(true)}>
                <DeviceMobile size={24} color="#FFF" weight="bold" />
              </Button>
            </Tooltip>
            <Dialog
              open={changeNumberDialog}
              onClose={() => setChangeNumberDialog(false)}
              PaperProps={{
                style: {
                  background: 'transparent',
                },
              }}
            >
              <PhoneDialog
                handleCloseModal={() => setChangeNumberDialog(false)}
              />
            </Dialog>
          </HeaderPhoneButton>
        )}
        <HeaderButton>
          <Button onClick={signOut}>SAIR</Button>
        </HeaderButton>
      </Header>

      {!isPaciente && isAdmin && !!phatoAccess && (
        <Form>
          <Button onClick={() => setAdminSearchDialog(true)}>
            Buscar exames (CRM / CPF / Nome)
          </Button>
          {isAdminSearchActive && (
            <ClearFiltersButton onClick={handleLimparFiltros}>
              Limpar filtros
            </ClearFiltersButton>
          )}
        </Form>
      )}

      {!isPaciente && !(isAdmin && !!phatoAccess) && (
        <Form>
          {isMedicoPhato ? (
            <>
              <FilterField>
                <span>CPF do paciente</span>
                <InputMask
                  type="text"
                  placeholder="CPF (opcional)"
                  value={medicoCpf}
                  disabled={Boolean(medicoNomePaciente.trim())}
                  onChange={(e) => setMedicoCpf(e.target.value)}
                  mask="999.999.999-99"
                />
              </FilterField>
              <FilterField>
                <span>Nome do paciente</span>
                <Input
                  type="text"
                  placeholder="Nome (opcional)"
                  value={medicoNomePaciente}
                  disabled={Boolean(medicoCpf.replace(/\D/g, ''))}
                  onChange={(e) => setMedicoNomePaciente(e.target.value)}
                />
              </FilterField>
            </>
          ) : (
            <Input
              onChange={(event) => setFiltro(event.target.value)}
              placeholder="Filtrar exames (nome, CPF...)"
              value={filtro}
            />
          )}

          <Button onClick={handleBuscarDados}>Procurar</Button>
          {hasActiveFilter && (
            <ClearFiltersButton onClick={handleLimparFiltros}>
              Limpar filtros
            </ClearFiltersButton>
          )}
        </Form>
      )}

      <Dialog
        open={adminSearchDialog}
        onClose={() => setAdminSearchDialog(false)}
        PaperProps={{
          style: {
            background: 'transparent',
          },
        }}
      >
        <AdminSearchDialog
          crm={adminCrm}
          cpf={adminCpf}
          nomePaciente={adminNomePaciente}
          onCrmChange={setAdminCrm}
          onCpfChange={setAdminCpf}
          onNomePacienteChange={setAdminNomePaciente}
          onClose={() => setAdminSearchDialog(false)}
          onSearch={handleBuscarAdminPhato}
        />
      </Dialog>
      {laudos.length === 0 && (
        <LaudoNoContent>
          <p>Nenhum exame encontrado.</p>
        </LaudoNoContent>
      )}
      {selectedLaudos.length > 0 && (
        <ActionsBar>
          <SelectedLaudosButton
            type="button"
            onClick={() => handleGenerateSelectedLaudosPdf(selectedLaudos)}
          >
            Abrir laudos selecionados ({selectedLaudos.length})
          </SelectedLaudosButton>
        </ActionsBar>
      )}
      <List>
        {laudos.map((item) => {
          const laudoKey = getLaudoKey(item);
          const selectable = isLaudoConcluido(item);
          const selected = selectedLaudos.some(
            (selectedLaudo) => getLaudoKey(selectedLaudo) === laudoKey,
          );

          return (
            <ExameCard
              key={laudoKey}
              cdLaudo={item.cdLaudo}
              cdPedRx={item.cdPedRx}
              nmPaciente={item.nmPaciente}
              dtLaudo={item.dtLaudo}
              isRecebimento={item.isRecebimento}
              dsExame={item.dsExame}
              nrControle={item.nrControle}
              from={item.from}
              status={item.status}
              visualizado={item.visualizado}
              dhVisualizacao={item.dhVisualizacao || ''}
              selected={selected}
              selectable={selectable}
              pdfDisabled={selectedLaudos.length > 0}
              isAdmin={!!isAdmin}
              onSelect={() => handleToggleLaudoSelection(item)}
              onPdfClick={() => handlePdfClick(item)}
              onAcessosClick={() =>
                setAcessosModal({
                  cdLaudo: item.cdLaudo,
                  from: item.from,
                  nmPaciente: item.nmPaciente,
                })
              }
            />
          );
        })}
      </List>

      <Dialog
        open={!!acessosModal}
        onClose={() => setAcessosModal(null)}
        PaperProps={{
          style: {
            background: 'transparent',
          },
        }}
      >
        {acessosModal && (
          <AcessosDialog
            cdLaudo={acessosModal.cdLaudo}
            from={acessosModal.from}
            nmPaciente={acessosModal.nmPaciente}
            handleCloseModal={() => setAcessosModal(null)}
            onFetchAcessos={handleGetLaudoAcessos}
          />
        )}
      </Dialog>
    </Container>
  );
}
